<template>
    <div class="ur-scheduler-header">
        <ur-button class="ur-scheduler-header__today-button" primary borderless @click="onToday">Today</ur-button>
        <ur-icon-button :disabled="!headerProps.previousPeriod" class="ur-scheduler-header__previous-button"
                        icon="collapse_menu" borderless
                        @click="onInput(headerProps.previousPeriod)" />
        <ur-month-picker class="ur-scheduler-header__date-picker" v-model="headerDate" @confirmed="changeHeaderDate"></ur-month-picker>
        <ur-icon-button :disabled="!headerProps.nextPeriod" class="ur-scheduler-header__next-button"
                        icon="collapse_menu" borderless
                        @click="onInput(headerProps.nextPeriod)" />
    </div>
</template>
<script>

    import CalendarMathMixin from './CalendarMathMixin'
    // ur-scheduler-header 는 스케쥴러의 헤더 영역을 나타내기 위한 컴포넌트로 문자와 선택 월을 표시합니다.
    // #ur-scheduler-header is used to indicate the text and selected month.
    export default {
        name: 'ur-scheduler-header',
        mixins: [CalendarMathMixin],
        props: {
            // $ver: v0.2.0
            // 오픈소스(vue-simple-calendar)에서 정의된 headerProps를 사용할 수 있다.
            // (참고 : https://github.com/richardtallent/vue-simple-calendar#readme)
            // #You can use headerProps defined in open source (vue-simple-calendar).
            // #(https://github.com/richardtallent/vue-simple-calendar#readme)
            // $tags IDE
            headerProps: {
                type: Object,
                required: false
            },
            // $ver: v0.2.0
            // 스케쥴러에 보여질 '월'을 선택합니다.
            // #Select the month to be applied to the scheduler.
            // $tags IDE
            showDate: {
                type: [String, Date],
                default: ''
            }
        },
        data() {
            return {
                headerDate: [new Date().getFullYear(),this.paddedMonth(new Date())]
            };
        },
        watch: {
            // 화살표 버튼으로 이동한 경우 달력 컴포넌트에도 값을 동일하게 맞춰 주어야한다.
            showDate(nDate) {
                this.headerDate = [nDate.getFullYear(), this.paddedMonth(nDate)];
            },
        },
        methods: {
            // TO-Be
            changeHeaderDate(date){
                this.$emit('input',new Date(date));
            },
            // 오늘날짜로 이동하는 함수
            onToday() {
                this.$emit('input', new Date());
            },
            // 앞뒤로 버튼을 누른 경우 해당 기간만큼 이동하도록 하는 함수
            onInput(d) {
                this.$emit('input', d);
            }
        }
    };
</script>
